require('./ctxNavigationMenu.style.scss');

class CtxNavigationMenuController {
    constructor($document, $element, $scope, $attrs) {
        this.isPopupVisible = false;
        this.$attrs = $attrs;
        this.id = this.$attrs.eventId;
        this.toggleSelect = () => this.isPopupVisible = !this.isPopupVisible;
        $document.on('click', (e) => {
            if ($element !== e.target && !$element[0].contains(e.target)) {
                $scope.$apply(() => {
                    $scope.$eval(this.isPopupVisible = false);
                    //TODO - remove listener
                });
            }
        });

    }
}

const ctxNavigationMenuComponent = {
    controller: CtxNavigationMenuController,
    scope: {},
    template: require('./ctxNavigationMenu.template.html'),
    bindings: {
        icon: '@',
        label: '@?',
        showSeparator: '@?',
        menuLinks: '<'
    }
};

CtxNavigationMenuController.$inject = ['$document', '$element', '$scope', '$attrs'];

module.exports = ctxNavigationMenuComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxNavigationMenu/ctxNavigationMenu.component.js